import React from 'react';
import Http from '../../utils/http';
import { Tabs, WhiteSpace, Badge, Toast,Modal } from 'antd-mobile';
import * as Api from "../../utils/api";
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css'
import Utils from '../../utils/utils'

import CommonHeader from "../../components/common/CommonHeader";
import CourceList from "../../components/List/CourceList";
const GLOBAL_IMAGE_URL = Api.imageGlobalUrl;
const alert = Modal.alert;
const HttpInstance = new Http();
const utils=new Utils();
export default class MyCource extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageTitle: "我的课程",
            courceList: [],
            currentTab: 0,
            isLoading: true,
            pager: {
                pageIndex: 1,
                pageSize: 10,
                orderType: 1,
                courseType: 2
            },
            hasMore: true,
            mySwiper: null
        }
    }
    render(){
        const _this = this;
        return (
            <div className="mycource-container">
                <CommonHeader history={ _this.props.history }></CommonHeader>
                <div className="tab-control">
                    <button
                        onClick={ _this.tabOnHandle.bind(_this,0) }
                        className={ _this.state.currentTab == 0 ? 'active': '' }>最近更新</button>
                    <button
                        onClick={ _this.tabOnHandle.bind(_this,1) }
                        className={ _this.state.currentTab == 1 ? 'active': '' }>最新订阅</button>
                    <button
                        onClick={ _this.tabOnHandle.bind(_this,2) }
                        className={ _this.state.currentTab == 2 ? 'active': '' }>最近播放</button>
                </div>
                <div className="workspace-zhan"></div>
                <div className="tab-container">
                    <div className="swiper-container">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <CourceList
                                    history={ _this.props.history }
                                    courceList ={ _this.state.courceList }
                                    hasMore = { _this.state.hasMore }
                                    isLoading={ _this.state.isLoading} ></CourceList>
                            </div>
                            <div className="swiper-slide">
                                <CourceList
                                    history={ _this.props.history }
                                    courceList ={ _this.state.courceList }
                                    hasMore = { _this.state.hasMore }
                                    isLoading={ _this.state.isLoading}></CourceList>
                            </div>
                            <div className="swiper-slide">
                                <CourceList
                                    history={ _this.props.history }
                                    courceList ={ _this.state.courceList }
                                    hasMore = { _this.state.hasMore }
                                    isLoading={ _this.state.isLoading}></CourceList>
                            </div>
                      </div>
                    </div>
                </div>
            </div>
        );
    }
    componentWillMount(){
        const _this = this;
        let currentTabIndex = localStorage.getItem("currentTab");
        if(currentTabIndex){
            _this.setState({
                currentTab: currentTabIndex
            })
        }
        document.title = _this.state.pageTitle;
        _this.queryMyCource();
        let isApp = HttpInstance.getSearchByName(this.props.location.search,"isApp");
        // let isIos = utils.judgeIsIOS();
        if(!isApp){
            utils.wxShareConfig(_this,isApp)
        }
    }
    componentDidMount() {
        const _this = this;
        document.body.style.backgroundColor = "#f7f7f7";
        _this.setState({
            mySwiper: new Swiper('.swiper-container', {
                on:{
                    slideChange: function(){
                      _this.setState({
                        currentTab: this.activeIndex
                      },()=>{
                        _this.trogglePager(this.activeIndex);
                      })
                    },
                },
            })
        })
        window.onscroll = function() {
          //为了保证兼容性，这里取两个值，哪个有值取哪一个
          //scrollTop就是触发滚轮事件时滚轮的高度
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var totalHeight = document.body.clientHeight;
            var seeHeight = document.documentElement.clientHeight;//浏览器可视窗口高度
            var scrollHeight = scrollTop+seeHeight+50;
            if(scrollHeight > totalHeight){
                //加载数据
                if(_this.state.hasMore){
                    let page = _this.state.pager.pageIndex + 1;
                    _this.setState({
                        pager: _this.copyObjAndTarget({pageIndex: page, pageSize: 10,orderType: _this.state.pager.orderType,courseType: 2})
                    },()=>{
                        _this.queryMyCource('pull');
                    })
                }
            }
        }


    }
    queryMyCource(flag) {
        const _this = this;
        let params = {};
        params.pageIndex = _this.state.pager.pageIndex;
        params.pageSize = _this.state.pager.pageSize;
        params.orderType = _this.state.pager.orderType;
        params.courseType = _this.state.pager.courseType;
        let response = HttpInstance.post(Api.QUERY_MYCOURCE_API,params);
        response.then((data) => {
            let responseData = data.data;
            _this.setState({
                isLoading: false
            })
            if(responseData.result) {
                let courceList = responseData.data
                if(courceList && courceList.length > 0){
                    if(flag == 'pull') {
                        _this.setState({
                            courceList: _this.state.courceList.concat(courceList)
                        })
                    } else {
                        _this.setState({
                            courceList: courceList
                        })
                    }
                } else {
                    _this.setState({
                        hasMore: false
                    })
                }
            }
        })
    }
    copyObjAndTarget(obj){
        return Object.assign({},obj);
    }
    /**
     * [playCource 切换按钮]
     * @author zhangzhaohui
     * @DateTime 2020-04-30T16:37:15+0800
     * @return   {[type]}                 [description]
     */
    tabOnHandle(index) {
        const _this = this;
        if(index == _this.state.currentTab) return ;
        _this.state.mySwiper.slideTo(index);
        _this.trogglePager(index);
        localStorage.setItem("currentTab",index);
    }
    /**
     * [trogglePager description]
     * @author lucky
     * @DateTime 2020-05-06T10:03:38+0800
     * @param    {[type]}                 index [description]
     * @return   {[type]}                       [description]
     */
    trogglePager(index){
        const _this = this;
        switch(index){
            case 0:
                _this.setState({
                    currentTab: index,
                    isLoading: true,
                    pager: _this.copyObjAndTarget({pageIndex: 1,pageSize: 10,orderType: 1,courseType: 2})
                },()=>{
                    _this.queryMyCource('troggle');
                })
                break;
            case 1:
                _this.setState({
                    currentTab: index,
                    isLoading: true,
                    pager: _this.copyObjAndTarget({ pageIndex: 1,pageSize: 10,orderType: 2,courseType: 2})
                },()=>{
                    _this.queryMyCource('troggle');
                })
                break;
            case 2:
                _this.setState({
                    currentTab: index,
                    isLoading: true,
                    pager: _this.copyObjAndTarget({ pageIndex: 1,pageSize: 10,orderType: 3,courseType: 2})
                },()=>{
                    _this.queryMyCource('troggle');
                })
                break;
        }
    }
}
